// extracted by mini-css-extract-plugin
export var arrows = "_71-6";
export var decrementer = "_71-a";
export var disabled = "_71-4";
export var error = "_71-1";
export var hiddenText = "_71-b";
export var incrementer = "_71-9";
export var input = "_71-8";
export var inputWrapper = "_71-0";
export var leadingIcon = "_71-c";
export var readonly = "_71-3";
export var regular = "_71-7";
export var small = "_71-5";
export var warning = "_71-2";